module.exports = __webpack_public_path__ + "static/media/logo nordeste pequeno.c0028266.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/logo nordeste pequeno.jpg
// module id = 367
// module chunks = 0